import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Component, OnInit, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import { AuthenticationService } from '../../shared'

@Component({
    templateUrl: './mfa-verify.component.html',
    styleUrls: ['../sign-in/sign-in.component.css'],
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class MfaVerifyComponent implements OnInit {
    faSpinner = faSpinner
    isSubmitting = false
    code = ''
    rememberDevice = false
    useRecoveryCode = false
    failed = false
    lockedOut = false
    rateLimited = false
    sessionMissing = false

    private http = inject(HttpClient)
    private router = inject(Router)
    private authentication = inject(AuthenticationService)

    ngOnInit(): void {
        this.sessionMissing = false
    }

    submit() {
        this.failed = false
        this.lockedOut = false
        this.rateLimited = false
        this.sessionMissing = false
        if (!this.code) return

        this.isSubmitting = true
        this.http
            .post<{ status?: string }>('api/Account/Mfa/Verify', {
                code: this.code,
                rememberDevice: this.rememberDevice,
                isRecoveryCode: this.useRecoveryCode,
            })
            .subscribe({
                next: result => {
                    if (result?.status === 'lockedOut') {
                        this.lockedOut = true
                        this.isSubmitting = false
                        return
                    }
                    if (result?.status !== 'signedIn') {
                        this.failed = true
                        this.isSubmitting = false
                        return
                    }
                    this.authentication.completeLogin().subscribe({
                        next: () => {
                            if (this.authentication.requestedRoute) {
                                this.router.navigateByUrl(this.authentication.requestedRoute)
                                this.authentication.requestedRoute = ''
                            } else {
                                this.router.navigate([''])
                            }
                        },
                        complete: () => {
                            this.isSubmitting = false
                        },
                    })
                },
                error: (err: HttpErrorResponse) => {
                    this.isSubmitting = false
                    if (err.status === 401) {
                        this.sessionMissing = true
                    } else if (err.status === 429) {
                        this.rateLimited = true
                    } else {
                        this.failed = true
                    }
                },
            })
    }

    backToSignIn() {
        this.router.navigate(['signin'])
    }
}
